/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import Menu from './Classes/Menu';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTableLight from "./Classes/ResponsiveTableLight";
import CountUpNumbers from './Classes/CountUpNumbers';
import SideNav from "./Classes/SideNav";
import LinkHandler from "./Classes/LinkHandler";
import BackToTop from "./Classes/BackToTop";
import Accordion from './Classes/Accordion';
import Highlights from "./Classes/Highlights";
import Slider from './Classes/Slider';
import CV from './Classes/CV';
import Matrix from './Classes/Matrix';
import HashHandler from './Classes/HashHandler';

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var focusHandlerInstance = null;
var menu = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;

var accordionInstance = null;
var accordionWpInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var matrixInstance = null;

var countUpInstance = null;
var sideNavInstanceH2 = null;
var sideNavInstanceH3 = null;
var backToTopInstance = null;
var highlightsInstance = null;
var swiperInstance = null;
var homeSwiperInstance = null;
var linkHandlerInstance = null;


export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();
  matrixInstance = new Matrix();

  menu = new Menu();

  responsiveTableInstance = new ResponsiveTableLight({
    tableSelector: '.ns-table-wrap table',
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-wrap > div > div'
  });


  accordionInstance = new Accordion({
    accordions: '.ns-accordion',
    pxCorrection: 0
  });

  new CV();

  linkHandlerInstance = new LinkHandler();

  accordionWpInstance = new Accordion({
    accordions: '.wp-accordion',
    pxCorrection: 0
  });

  
  new HashHandler();

  document.addEventListener('noteLoaded', (e) => {
    responsiveTableInstance = new ResponsiveTableLight({
      tableSelector: '.nhsnote-box .ns-table-wrap table',
      tableComponentSelector: '.ns-table-wrap',
      tableContainerSelector: '.ns-table-wrap > div > div'
    });
  });

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.ns-countup-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: ['’', ','],
  });

  // sideNavInstanceH2 = new SideNav({
  //   sideNavTitles: '.ns-title-h2.side-nav'
  // });


  backToTopInstance = new BackToTop({
    buttonClass: '.js-backtotop-toggle',
    stickyClass: '.prev-next__inner',
    fadeInPosition: 100,
    correction: 0,
    toolbarClass: '.js-backtotop-toggle'
  });

  highlightsInstance = new Highlights({
    container: '.ns-timeline',
    title: '.ns-timeline__title',
    toggler: '.ns-paragraph--more'
  });
  
  sideNavInstanceH3 = new SideNav({
    sideNavTitles: '.ns-title-h2.side-nav, .ns-title-h3.side-nav'
  });

  swiperInstance = new Slider();

});
